import PhoneLink from '@@/common/components/PhoneLink';

type TKnockoutCopy = {
  phoneNumber: string;
};

export default function KnockoutCopy({ phoneNumber }: TKnockoutCopy) {
  return (
    <>
      This can happen when we are unable to verify your personal information. If
      you still want a quote and did not provide accurate personal information
      initially, please begin a fresh quote with your correct information. For
      any questions or further assistance, please give us a call at{' '}
      <PhoneLink phoneNumber={phoneNumber} />.
    </>
  );
}
